import Corona from './corona.jpeg';
import './Hotel.css';

export const HotelCoral = () => {
  return (
    <>
      <section className="snn-page-section snn-hotel-wrapper">
        <div className="snn-hotel-description">
          <h2 className="snn-title">CORONA, Hotel & Spa</h2>
          <p>Stay from November 19th to 21st, 2025</p>
          <p>Rate from Sunday to Thursday</p>
          <ul>
            <li>King or Two Queen Beds for up to two people: <strong>$1,776.93 MXN</strong></li>
            <li>
              <strong>Contact:</strong>
              <ul>
                <li>📞 Tel: +52 646 176 0901</li>
                <li>💬 WhatsApp: +52 646 255 9145</li>
                <li>✉️ Email: <a className="snn-email-link" href="mailto:reserv@hotelcorona.com.mx">reserv@hotelcorona.com.mx</a></li>
              </ul>
            </li>
            <li>When booking, please mention the Energy Storage Discussions event to ensure the group rate.</li>
            <li>Check-in: November 19, 2025</li>
            <li>Check-out: November 21, 2025</li>
          </ul>
          <hr style={{margin: '32px 0'}} />
          <h3 className="snn-title">🚍 Transportation from Tijuana Airport to Ensenada</h3>
          <p>If you are flying into Tijuana International Airport (TIJ), the easiest way to reach Ensenada is by intercity bus.</p>
          <ul>
            <li><strong>Bus Company:</strong> Autobuses ABC</li>
            <li><strong>Duration:</strong> ~2 hours</li>
            <li><strong>Frequency:</strong> Every 30–60 minutes</li>
            <li><strong>Tickets:</strong> Purchase at the station or online at <a href="https://abc.com.mx/" target="_blank" rel="noopener noreferrer">abc.com.mx</a></li>
            <li><strong>Departure:</strong> Tijuana Central Bus Station</li>
            <li><strong>Arrival:</strong> Central de Autobuses de Ensenada (10 minutes from downtown)</li>
            <li>From the Ensenada bus station, you can take a short taxi or ride-share to your hotel.</li>
          </ul>
        </div>
        <div className="snn-hotel-image">
          <img src={Corona} alt="Hotel img" />
        </div>
      </section>
    </>
  );
};
